module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "schema-purpose"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Schema Purpose Section\n                      "), _c('a', {
    attrs: {
      "href": '#' + _vm.pPurposeBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pPurposeBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pPurposeBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Purpose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTablePurpose),
      expression: "filterTablePurpose"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTablePurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "add_purpose"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTableEntry()
      }
    }
  }, [_vm._v("New Section")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datatable', {
    ref: "schema_purpose_table",
    attrs: {
      "id": _vm.schema_purpose_id,
      "dtOptions": _vm.dtOptionsSchemaPurpose,
      "dtHeaders": _vm.dtHeadersSchemaPurpose
    }
  })], 1)])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Schema Purpose Section",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                      " + _vm._s(error.label) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "schema_purpose"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence Purpose")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.licence_purpose),
      expression: "sectionPurpose.licence_purpose"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "name": "select-purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionPurpose, "licence_purpose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section Label")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.section_label),
      expression: "sectionPurpose.section_label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionPurpose.section_label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionPurpose, "section_label", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section Index")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.index),
      expression: "sectionPurpose.index"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionPurpose.index)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionPurpose, "index", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.savePurpose()
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ff9cd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/main/schema_purpose.vue
// module id = 1013
// module chunks = 0